import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  EmailCampaignRepository,
  EmailCampaignService,
  EmailCampaignDomainRepository,
  EmailCampaignDomainService,
  EmailCampaignEmailSenderRepository,
  EmailCampaignEmailSenderService,
  EmailCampaignDomainResolverService,
  EmailCampaignDomainsResolverService,
  EmailCampaignDomainsRouteResolverService,
  EmailCampaignDomainsPreloaderService,

  CampaignsSendersDomainColumnService,
  CampaignsSendersDomainGridable,
  EmailCampaignDomainsColumnService,
  EmailCampaignDomainGridService,

  CampaignsSendersFlowAddDomainFormService,
  CampaignsSendersFlowSendModalFormService,
  CampaignsSendersFlowVerifyEmailFormService,
  CampaignsSendersFlowCompleteDomainFormService,
  CampaignsEmailSenderModalFormService,
  CampaignsEmailFooterModalFormService,

  EmailCampaignRecipientsRepository,
  EmailCampaignRecipientsService,

  EmailCampaignMessageRepository,
  EmailCampaignMessageService,

  EmailCampaignRecipientService,

  EmailCampaignOpenRepository,
  EmailCampaignOpenService,

  EmailCampaignUnsubscribeRepository,
  EmailCampaignUnsubscribeService,

  EmailCampaignSpamReportRepository,
  EmailCampaignSpamReportService,

  EmailCampaignClickSummaryRepository,
  EmailCampaignClickSummaryService,

  EmailCampaignClickSummaryStatisticsRepository,
  EmailCampaignClickSummaryStatisticsService,

  EmailCampaignClickRepository,
  EmailCampaignClickService,

  EmailCampaignSettingsRepository,
  EmailCampaignSettingsService,

  EmailCampaignProgressResolver,

  EmailCampaignDomainWebSocketService,
  EmailCampaignDomainWebSocketResolver,

  EmailCampaignDomainEntriTokenRepository,
  EmailCampaignDomainEntriTokenSellRepository,
  EmailCampaignDomainEntriService,
  EmailCampaignDomainEntriSellService,
  EmailCampaignDomainEntriAdapter,

  FollowUpRepository,
  FollowUpDetailsRepository,
}

export type EmailCampaignsServices = keyof typeof SERVICES

export const EMAIL_CAMPAIGNS_SERVICE_TYPES: Record<EmailCampaignsServices, symbol> =
  makeServicesTypes<EmailCampaignsServices>(enumKeysToArray<EmailCampaignsServices>(SERVICES))
